import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a28251ec52c570014bdb8aa_1781528436791_bca62f50/resetrunning/src/app/events/components/EventsClient.tsx");
